import { SupportUserPermission } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllSupportUserPermissions = () =>
  getAllEnumOptions(SupportUserPermission)

export const getSupportUserPermissionLabel = (key?: SupportUserPermission) => {
  if (key === null || typeof key === 'undefined') return ''

  return SupportUserPermission[key]
}
